module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/094-south-korea-b0ef358d7132518287785988851875d0.svg";